<div class="panel" *ngIf="movements">
  <h2>
    Pièces jointes
    <ng-container *ngIf="attachmentsCount > 0">({{ attachmentsCount }})</ng-container>
  </h2>
  
  <div class="btn-toolbar">

    <a *ngIf="attachmentsCount > 0" class="btn btn-small btn-gray" title="Télécharger toutes les pièces jointes" href="/files/shares-ledger/attachments-for-entity/{{ entity.id }}">
      <t-icon name="file_download"></t-icon>
      <span class="text">Télécharger</span>
    </a>

  </div>
  
  <div *ngFor="let movement of movements">

    <h3 style="padding: 8px 16px; background-color: #f0f0f0;">Mouvement #{{ movement.no }}</h3>

    <table class="attachments">
      <tbody>
        <tr *ngFor="let attachment of movement.attachments">
          
          <!--Details-->
          <td>
            {{ attachment.filename }}
    
            <div class="item-details">
              <div>
                <label>Signature</label>
                <span class="digest" title="{{ attachment.digest }}">
                  {{ attachment.digest}}
                </span>
              </div>
              <div>
                <label>Taille</label>
                <span>{{ attachment.filesize | filesize }}</span>
              </div>
            </div>
    
          </td>
    
          <td style="width: 50px;" class="actions">
            <a class="action-btn" href="/files/shares-ledger/attachment/{{ entity.id }}/{{ movement.id }}/{{ attachment.id }}">
              <t-icon name="file_download"></t-icon>
            </a>
          </td>
    
        </tr>
      </tbody>
    </table>

  </div>

  <div class="empty-table compact" *ngIf="movements.length === 0">
    <p>Aucune pièce jointe dans cette entité</p>
  </div>

</div>